import React, { useEffect, useRef, useState } from "react";
import Spinner from "../../components/Spinner";
import toast from "react-hot-toast";
import { fetchDriverProfile } from "../../services/profile";
import { useMutation } from "@tanstack/react-query";
import DriverProfile from "../../components/DriverProfile";
import { useParams } from "react-router-dom";

const DriverProfilePage = () => {
  const { driverId } = useParams();
  const [driverData, setDriverData] = useState(null);
  const [loading, setLoading] = useState(true);
  const calledRef = useRef(false);

  const { mutate } = useMutation({
    mutationFn: () => fetchDriverProfile(driverId),
    onSuccess: (data) => {
      setDriverData(data.data);
      setLoading(false);
      toast.success("تم تحويلك لصفحة السائق");
    },
    onError: () => {
      setLoading(false);
      toast.error("فشل فتح صفحة السائق");
    },
  });

  useEffect(() => {
    if (!calledRef.current) {
      mutate();
      calledRef.current = true;
    }
  }, [mutate]);

  if (loading) return <Spinner />;
  if (!driverData) return null;

  return <DriverProfile driver={driverData} />;
};

export default DriverProfilePage;
